export const validateTimeRefreshOrderRange = (value) => {
    if (Number(value) < 0 || Number(value) > 600) {
      return "osfc.messages.validation.timeRefreshOrderRange";
    }
  };